import { useEffect, useRef } from 'react';

interface CalendlyWidgetProps {
  url: string;
  height?: number;
  minWidth?: number;
}

export default function CalendlyWidget({
  url,
  height = 700,
  minWidth = 320,
}: CalendlyWidgetProps) {
  const calendlyRef = useRef<HTMLDivElement>(null);
  const initializedRef = useRef(false);

  useEffect(() => {
    if (initializedRef.current || !calendlyRef.current) return;

    const initCalendly = () => {
      if (initializedRef.current || !calendlyRef.current) return;
      const Calendly = (window as any).Calendly;
      if (Calendly) {
        Calendly.initInlineWidget({
          url,
          parentElement: calendlyRef.current,
        });
        initializedRef.current = true;
      }
    };

    if ((window as any).Calendly) {
      initCalendly();
    } else {
      const interval = setInterval(() => {
        if ((window as any).Calendly) {
          initCalendly();
          clearInterval(interval);
        }
      }, 300);

      const timeout = setTimeout(() => clearInterval(interval), 10000);

      return () => {
        clearInterval(interval);
        clearTimeout(timeout);
      };
    }
  }, [url]);

  return (
    <div
      ref={calendlyRef}
      className="calendly-inline-widget rounded-xl overflow-hidden border border-background-200/70 bg-background-50"
      style={{ minWidth: `${minWidth}px`, height: `${height}px` }}
      data-url={url}
    />
  );
}